export default __webpack_public_path__ + "843682c0a1c3b397dc6b340e07fab5f9.svg";